import React, { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom'

import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import AboutUs from 'components/AboutUs'
import Concept from 'components/Concept'
import CustomButton from 'components/CustomButton'
import FAQ from 'components/FAQ'
import SupportList from 'components/SupportList'
import HowItWorks from 'components/HowItWorks'
import MainImage from 'components/MainImage'
import Reward from 'components/Reward'
import StickyBanner from 'components/StickyBanner'
import EventList from 'pages/EventList'
import NewsList from 'pages/NewsList'
import SectionHeader from 'components/SectionHeader'
import { useEvent, EntryState } from 'hooks/useEvent'
import Typography from '@mui/material/Typography'
export default function Top() {
  const { t } = useTranslation();
  const { palette, spacing, breakpoints } = useTheme()
  const { push } = useHistory()
  const isMobile = useMediaQuery(breakpoints.down('sm'))
  const { eventResources } = useEvent()

  useEffect(() => {
    if (process.env.REACT_APP_ACCOUNT_ID === '39' && process.env.REACT_APP_TOP_REDIRECT) {
      push(process.env.REACT_APP_TOP_REDIRECT)
    }
  }, [push])

  const More = ({ text, href }) => (
    <div
      style={{
        marginBottom: spacing(6),
        background: palette.background.paper,
        padding: spacing(3),
      }}
    >
      <CustomButton
        arrow
        onClick={() => {
          if (href.startsWith('/')) {
            push(href)
          } else {
            window.open(href)
          }
        }}
      >
        {text}
      </CustomButton>
    </div>
  )

  return (
    <div style={{ background: palette.background.default }}>
      <MainImage src="/images/main.jpg" alt="トップ" type="top" />
      <Concept />
      {process.env.REACT_APP_ACCOUNT_ID === '41' && (
          <div style={{ background: palette.background.paper, marginBottom: spacing(6) }}>
              <SectionHeader primary="エントリーの流れ" />
              <div style={{ padding: spacing(0, 3, 3, 3) }}>
                <div style={{
                  background: '#fff5f5',
                  border: `2px solid ${palette.primary.main}`,
                  borderRadius: 4,
                  padding: spacing(2),
                  marginBottom: spacing(6),
                }}>
                  <Typography style={{
                    color: palette.primary.main,
                    fontWeight: 'bold',
                    fontSize: 16,
                    marginBottom: spacing(1),
                  }}>
                    エントリーの順番にご注意ください
                  </Typography>
                  <Typography style={{ fontSize: 14, lineHeight: 1.6 }}>
                    エントリーは必ず <strong>Runtripから先</strong> に行ってください。<br />
                    明治でのエントリー時にRuntrip IDの入力が必要なため、この順番でないとエントリーできません。
                  </Typography>
                </div>
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  border: `1px solid ${palette.divider}`,
                  marginBottom: spacing(6),
                }}>
                  <thead>
                    <tr style={{ background: palette.grey[100] }}>
                      <th style={{
                        border: `1px solid ${palette.divider}`,
                        padding: spacing(2),
                        textAlign: 'left',
                        fontWeight: 'bold',
                      }}>あなたの状況</th>
                      <th style={{
                        border: `1px solid ${palette.divider}`,
                        padding: spacing(2),
                        textAlign: 'left',
                        fontWeight: 'bold',
                      }}>次のアクション</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr style={{ background: palette.grey[50] }}>
                      <td style={{
                          border: `1px solid ${palette.divider}`,
                          padding: spacing(2),
                      }}>両方のID<span style={{ fontSize: 12 }}>をお持ちの方</span></td>
                      <td style={{
                          border: `1px solid ${palette.divider}`,
                          padding: spacing(2),
                      }}>
                        <div style={{ display: 'flex', gap: spacing(1.5), flexDirection: isMobile ? 'column' : 'row', flexWrap: 'wrap' }}>
                          <div style={{ flex: 1, minWidth: 120 }}>① <a
                            href="https://campaign.meiji.runtrip.jp/events/766"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'rgb(3, 175, 122)', textDecoration: 'underline', fontWeight: 'bold' }}
                          >Runtrip</a> <span style={{ fontSize: 12 }}>でエントリー</span></div>
                          <div style={{ flex: 1, minWidth: 120, paddingLeft: isMobile ? 0 : spacing(2) }}>② <a
                            href="https://campaign.meiji.co.jp/campaignDetail/66544998107506/5715d29c-d100-4c0c-8e19-b76ca99d1caa?from=runtrip2602"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: palette.primary.main, textDecoration: 'underline', fontWeight: 'bold' }}
                          >明治</a> <span style={{ fontSize: 12 }}>でエントリー</span></div>
                          <div style={{ flex: 1, minWidth: 120 }}></div>
                        </div>
                      </td>
                  </tr>
                    <tr>
                      <td style={{
                        border: `1px solid ${palette.divider}`,
                        padding: spacing(2),
                      }}>Runtrip ID<span style={{ fontSize: 12 }}>のみお持ちの方</span></td>
                      <td style={{
                        border: `1px solid ${palette.divider}`,
                        padding: spacing(2),
                      }}>
                        <div style={{ display: 'flex', gap: spacing(1.5), flexDirection: isMobile ? 'column' : 'row', flexWrap: 'wrap' }}>
                          <div style={{ flex: 1, minWidth: 120 }}>① <a
                            href="https://id.meiji.co.jp/user/?from=runtrip2602"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: palette.primary.main, textDecoration: 'underline', fontWeight: 'bold' }}
                          >明治</a> <span style={{ fontSize: 10 }}>の会員登録</span></div>
                          <div style={{ flex: 1, minWidth: 120, paddingLeft: isMobile ? 0 : spacing(2) }}>② <a
                            href="https://campaign.meiji.runtrip.jp/events/766"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'rgb(3, 175, 122)', textDecoration: 'underline', fontWeight: 'bold' }}
                          >Runtrip</a> <span style={{ fontSize: 12 }}>でエントリー</span></div>
                          <div style={{ flex: 1, minWidth: 120 }}>③ <a
                            href="https://campaign.meiji.co.jp/campaignDetail/66544998107506/5715d29c-d100-4c0c-8e19-b76ca99d1caa?from=runtrip2602"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: palette.primary.main, textDecoration: 'underline', fontWeight: 'bold' }}
                          >明治</a> <span style={{ fontSize: 12 }}>でエントリー</span></div>
                        </div>
                      </td>
                    </tr>
                    <tr style={{ background: palette.grey[50] }}>
                      <td style={{
                        border: `1px solid ${palette.divider}`,
                        padding: spacing(2),
                      }}>明治会員 ID<span style={{ fontSize: 12 }}>のみお持ちの方</span></td>
                      <td style={{
                        border: `1px solid ${palette.divider}`,
                        padding: spacing(2),
                      }}>
                        <div style={{ display: 'flex', gap: spacing(1.5), flexDirection: isMobile ? 'column' : 'row', flexWrap: 'wrap' }}>
                          <div style={{ flex: 1, minWidth: 120 }}>① <a
                            href="https://runtrip.jp/register"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'rgb(3, 175, 122)', textDecoration: 'underline', fontWeight: 'bold' }}
                          >Runtrip</a> <span style={{ fontSize: 10 }}>の会員登録</span></div>
                          <div style={{ flex: 1, minWidth: 120, paddingLeft: isMobile ? 0 : spacing(2) }}>② <a
                            href="https://campaign.meiji.runtrip.jp/events/766"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'rgb(3, 175, 122)', textDecoration: 'underline', fontWeight: 'bold' }}
                          >Runtrip</a> <span style={{ fontSize: 12 }}>でエントリー</span></div>
                          <div style={{ flex: 1, minWidth: 120 }}>③ <a
                            href="https://campaign.meiji.co.jp/campaignDetail/66544998107506/5715d29c-d100-4c0c-8e19-b76ca99d1caa?from=runtrip2602"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: palette.primary.main, textDecoration: 'underline', fontWeight: 'bold' }}
                          >明治</a> <span style={{ fontSize: 12 }}>でエントリー</span></div>
                        </div>
                      </td>
                    </tr>
                  <tr>
                      <td style={{
                          border: `1px solid ${palette.divider}`,
                          padding: spacing(2),
                      }}>両方のID<span style={{ fontSize: 12 }}>をお持ちでない方</span></td>
                      <td style={{
                          border: `1px solid ${palette.divider}`,
                          padding: spacing(2),
                      }}>
                        <div style={{ display: 'flex', gap: spacing(1.5), flexDirection: isMobile ? 'column' : 'row', flexWrap: 'wrap' }}>
                          <div style={{ flex: 1, minWidth: 120, whiteSpace: isMobile ? 'normal' : 'nowrap' }}>① <a
                            href="https://runtrip.jp/register"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'rgb(3, 175, 122)', textDecoration: 'underline', fontWeight: 'bold' }}
                          >Runtrip</a>、<a
                            href="https://id.meiji.co.jp/user/?from=runtrip2602"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: palette.primary.main, textDecoration: 'underline', fontWeight: 'bold' }}
                          >明治</a><span style={{ fontSize: 10 }}>の会員登録</span></div>
                          <div style={{ flex: 1, minWidth: 120, paddingLeft: isMobile ? 0 : spacing(2) }}>② <a
                            href="https://campaign.meiji.runtrip.jp/events/766"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'rgb(3, 175, 122)', textDecoration: 'underline', fontWeight: 'bold' }}
                          >Runtrip</a> <span style={{ fontSize: 12 }}>でエントリー</span></div>
                          <div style={{ flex: 1, minWidth: 120 }}>③ <a
                            href="https://campaign.meiji.co.jp/campaignDetail/66544998107506/5715d29c-d100-4c0c-8e19-b76ca99d1caa?from=runtrip2602"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: palette.primary.main, textDecoration: 'underline', fontWeight: 'bold' }}
                          >明治</a> <span style={{ fontSize: 12 }}>でエントリー</span></div>
                        </div>
                      </td>
                  </tr>
                  </tbody>
                </table>
                <div style={{ marginTop: spacing(6), textAlign: 'center' }}>
                  <img src="/images/entry-flow.png" alt="エントリーの流れ" style={{ maxWidth: '100%', height: 'auto' }} />
                </div>
              </div>
          </div>
      )}
      {Boolean(process.env.REACT_APP_CONCEPT_HREF) && (
        <More text="詳細を見る" href={process.env.REACT_APP_CONCEPT_HREF} />
      )}
      <NewsList limit={process.env.REACT_APP_ACCOUNT_ID === '34' ? 5 : 3} />
      <More text={t("Word.NewsList")} href="/news" />
      <HowItWorks />
      {process.env.REACT_APP_ACCOUNT_ID === '34' && (
          <div>
              <img style={{objectFit: 'contain', width: '100%', marginBottom: spacing(2)}} alt="" src={"/images/top-step-up.png"}/>
          </div>
      )}
      {process.env.REACT_APP_ACCOUNT_ID === '41' && (
          <div>
              <img style={{objectFit: 'contain', width: '100%', marginBottom: spacing(2)}} alt="" src={"/images/event-1.png"}/>
          </div>
      )}
      <Reward />
      <EventList limit={7} />
      <More text={t("Word.EventsList")} href="/events" />
      {process.env.REACT_APP_ACCOUNT_ID === '40' && (
          <div style={{background: palette.background.paper, marginBottom: spacing(6)}}>
            <SectionHeader primary="Rare Disease Day とは" />
            <Typography
                variant="body2"
                style={{
                  margin: spacing(0, 3, 3),
                  padding: spacing(3),
                  lineHeight: 1.5,
                }}
              >
                Rare Disease Day（世界希少・難治性疾患の日、以下RDD）は、より良い診断や治療による希少・難治性疾患の患者さんの生活の質（QOL）の向上を目指して、スウェーデンで2008年から始まった活動です。現在は延べ100カ国以上で、様々なRDDに関連する企画が開催されています。<br />
                日本では、2010年の東京で初めて開催されて以来、毎年着実に開催団体が増え、開催地域も広がっています。<br />
                来場者・参加者は、患者さんやご家族に加え、医療従事者、医薬品研究開発者、そして一般の方々まで多岐にわたります。RDDは、希少・難治性疾患の患者さん・ご家族と一般社会をつなぐ重要な取り組みとして、年々その認知度・重要性が高まっています。
            </Typography>
            <SectionHeader primary="希少疾患とは" />
            <Typography
              variant="body2"
              style={{
                margin: spacing(0, 3, 3),
                padding: spacing(3),
                lineHeight: 1.5,
              }}
            >
                世界では約7000の希少疾患が存在し、3億人が影響を受けているといわれています。<br />
                日本においては患者数が5万人未満である疾患を希少疾患としています。<br />
                一般的な症状も多く、診断や治療の遅れ、そして周囲のサポートが課題となっています。
            </Typography>
            <SectionHeader primary="サノフィは日本初開催から「Rare Disease Day」を支援" />
            <Typography
              variant="body2"
              style={{
                margin: spacing(0, 3, 6),
                padding: spacing(3),
                lineHeight: 1.5,
              }}
            >
                サノフィは、希少疾患コミュニティの声を社会に届け、誰もが公平に医療へアクセスできる環境を実現するというミッションの実現に向け、毎年、世界各地でRDDを記念した活動を実施しています。サノフィは、希少疾患領域のリーディングカンパニーとして、社会における希少・難治性疾患の認知向上を目指した同活動に賛同し、2010年日本初開催以来、RDDイベントの支援をしています。（前身である、ジェンザイム・ジャパン株式会社時代を含む）。サノフィは、ライソゾーム病6疾患（ゴーシェ病、ファブリー病、ポンペ病、ムコ多糖症I型、ムコ多糖症II型、酸性スフィンゴミエリナーゼ欠損症（ASMD）※）および血友病A、血友病Bおよび後天性血栓性血小板減少性紫斑病の治療薬を提供しています（2026年1月時点）。<br />
                ※ASMDは別名ニーマン・ピック病A型、A/B型、B型とも呼ばれています。
            </Typography>
          </div>
      )}
      {process.env.REACT_APP_ACCOUNT_ID === '38' && (
          <>
            <div style={{background: palette.background.paper, marginBottom: spacing(6)}}>
                <SectionHeader primary="GARMIN RUN ONLINE を楽しむために、おすすめのガーミン！" />
                <div>
                  <img style={{ objectFit: 'contain', width: '100%' }} alt="" src="/images/reward_garmin570.png"/>
                </div>
                <div style={{ textAlign: 'center', marginBottom: spacing(3)}}>
                  <img src="/images/garmin_text.svg" alt="" style={{ width: '60%', height: 'auto' }}/>
                </div>
                <div style={{ textAlign: 'center', padding: spacing(0, 3)}}>
                <div style={{ fontWeight: 'bold'}}>Forerunner 570のおすすめポイント</div>
                  <ol style={{ textAlign: 'left', display: 'inline-block', paddingLeft: spacing(6)}}>
                    <li>高彩度AMOLEDディスプレイで情報がすぐに確認できる！</li>
                    <li>心拍計の精度が向上し、より正確にデータを計測できる！</li>
                    <li>日々計測したデータを元に目標に向けてトレーニングをサポート</li>
                  </ol>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    padding: spacing(0, 3),
                    marginBottom: spacing(3)
                  }}
                >
                  Forerunner 570の詳細は
                  <a
                    href="https://www.garmin.co.jp/products/wearables/forerunner-570-47-black/?utm_source=runtrip&utm_medium=paid&utm_campaign=20251210forerunner-570-47-black_rt"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    こちら
                  </a>
                </div>
                <div style={{ textAlign: 'center', padding: spacing(0, 3) }}>
                    <img src="/images/akasaki_kawauchi.png" alt="" style={{ width: '100%', objectFit: 'contain', marginBottom: spacing(2) }}/>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    justifyContent: 'center',
                    gap: '12px',
                    padding: spacing(0, 3),
                    marginBottom: spacing(6),
                    overflow: 'hidden',
                  }}
                >
                  <iframe
                    src="https://www.youtube.com/embed/1RQNCxRAfwY?loop=1&playlist=1RQNCxRAfwY"
                    title="【Garmin】ベルリンマラソン2位・赤﨑暁選手が語る 走りを支える&quot;データ活用法&quot;とは？"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      border: '0',
                      width: isMobile ? '100%' : 'calc(50%)',
                      aspectRatio: '16/9',
                      minWidth: '120px',
                    }}
                  />
                  <iframe
                    src="https://www.youtube.com/embed/-c9L1ibfvuYk?loop=1&playlist=c9L1ibfvuYk"
                    title="【Garmin】最新ウォッチForerunner 570を活用した快眠のコツ｜川内選手の睡眠データを大公開！スリープトレーナーが質の良い睡眠の特徴を解説！"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      border: '0',
                      width: isMobile ? '100%' : 'calc(50%)',
                      aspectRatio: '16/9',
                      minWidth: '120px',
                    }}
                  />
                </div>
                <div div style={{ textAlign: 'center' }}>
                  <a href="https://www.garmin.co.jp/event/2025/give-a-garmin/?utm_source=runtrip&utm_medium=paid&utm_campaign=20251210give-a-garmin_rt#run" target="_blank" rel="noopener noreferrer">
                    <img
                      style={{ objectFit: 'contain', width: '50%', marginBottom: spacing(6) }}
                      alt=""
                      src="/images/detail.svg"
                    />
                  </a>
                </div>
            </div>
          </>
      )}
      <FAQ />
      {process.env.REACT_APP_ACCOUNT_ID === '40' && (
        <div style={{
          padding: spacing(0, 6),
        }}>
          <Typography variant="caption">
            MAT-JP-2600135-2.0-01/2026
          </Typography>
        </div>
      )}
      {['37,38'].includes(process.env.REACT_APP_ACCOUNT_ID) && (
        <SupportList/>
      )}
      <AboutUs />
      {eventResources.some(event => event.event.entryState === EntryState.OPENING) && (
        <StickyBanner
          actionText="エントリーはこちら！！"
          actionUrl={process.env.REACT_APP_TOP_ENTRY_BUTTON_URL || "/events"}
        />
      )}
    </div>
  )
}
